import React from 'react';

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {' '}
            <video
              src="/0_Office_Laptop_1280x720.mp4"
              autoPlay
              muted
              loop
              playsInline
              style={{
                width: '100%',
                objectFit: 'cover',
              }}
            />
            {/* <img
              src="https://img.freepik.com/free-photo/standard-quality-control-concept-m_23-2150041861.jpg?t=st=1756150873~exp=1756154473~hmac=2a8e2273ccf4a7e5866ab48e721059702639346440303c4bc1c4dc8247886424&w=1480"
              className="img-responsive"
              alt=""
            />{' '} */}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2
                style={{
                  fontSize: '2.5rem',
                  fontWeight: 'bold',
                  color: '#222',
                  marginBottom: 12,
                }}
              >
                About Us
              </h2>
              <p>{props.data ? props.data.paragraph : 'loading...'}</p>
              <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : 'loading'}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : 'loading'}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
